import { styled } from "@mui/material";
import { useCheckoutCartInfo } from "../../hooks/useCheckoutCartInfo";
import { AsyncCheckoutCartProduct } from "./AsyncCheckoutCartProduct";

const CartContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  width: "100%",
});

export const MobileCart = () => {
  const { items } = useCheckoutCartInfo();

  return (
    <CartContainer>
      {items.map((item) => (
        // @ts-ignore
        <AsyncCheckoutCartProduct key={item.stacklineSku} product={item} />
      ))}
    </CartContainer>
  );
};
